// Apply the inline styles from data attributes to inventory elements
document.addEventListener('DOMContentLoaded', function() {
  const inventoryElements = document.querySelectorAll('.laber_total_items, .laber_progress');
  
  inventoryElements.forEach(element => {
    if (element.dataset.bgColor) {
      element.style.backgroundColor = element.dataset.bgColor;
    }
    
    if (element.dataset.height) {
      element.style.height = element.dataset.height + 'px';
    }
    
    if (element.dataset.width) {
      element.style.width = element.dataset.width + '%';
    }
  });
  
  // Initialize simplified variant media switching
  setupSimpleVariantMediaSwitching();
});

// Function to handle variant image switching - showing one image per variant
function setupSimpleVariantMediaSwitching() {
  // Get all media items
  const allMediaItems = Array.from(document.querySelectorAll('.product__media-item'));
  const allThumbnails = Array.from(document.querySelectorAll('.thumbnail-list__item'));
  let isInitialized = false;
  
  // Make all media items available in the DOM but initially hide them
  allMediaItems.forEach(item => {
    // Remove inline display style but don't hide the items yet
    item.style.display = '';
    item.classList.remove('is-active');
  });
  
  // Utility function to find the variant ID
  function getCurrentVariantId() {
    // Method 1: Check for hidden input in the form
    const variantIdInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (variantIdInput && variantIdInput.value) {
      return variantIdInput.value;
    }
    
    // Method 2: Check for selected radio button
    const selectedRadio = document.querySelector('variant-radios input[type="radio"]:checked');
    if (selectedRadio && selectedRadio.value) {
      return selectedRadio.value;
    }
    
    // Method 3: Check for selected dropdown option
    const selectedOption = document.querySelector('variant-selects select option:checked');
    if (selectedOption && selectedOption.value) {
      return selectedOption.value;
    }
    
    // Method 4: Check URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    if (variantId) {
      return variantId;
    }
    
    console.log("Could not determine current variant ID");
    return null;
  }
  
  // Function to update displayed media for a variant
  function updateActiveMedia(variantId) {
    if (!variantId) {
      console.log("No variant ID provided to updateActiveMedia");
      return;
    }
    
    console.log(`Updating media for variant ID: ${variantId}`);
    
    // First, hide all media items by removing is-active class and setting display none
    // This only affects the media items, not the variant selectors
    allMediaItems.forEach(item => {
      item.classList.remove('is-active');
      item.style.display = 'none';
    });
    
    // Find media items that match this variant
    let matchingMedia = allMediaItems.filter(item => {
      return item.classList.contains(`product__media-item--variant-${variantId}`) || 
             item.getAttribute('data-variant-id') === variantId;
    });
    
    console.log(`Found ${matchingMedia.length} matching media items`);
    
    // If no direct matches, check if there are media items with variant option values
    if (matchingMedia.length === 0) {
      // Try to match by option value (color, size, etc.)
      const variantSelects = document.querySelectorAll('variant-selects select');
      const variantRadios = document.querySelectorAll('variant-radios input[type="radio"]:checked');
      
      // Get selected option values
      let selectedOptions = [];
      
      if (variantSelects.length > 0) {
        selectedOptions = Array.from(variantSelects).map(select => select.value.toLowerCase().trim());
      } else if (variantRadios.length > 0) {
        selectedOptions = Array.from(variantRadios).map(radio => radio.value.toLowerCase().trim());
      }
      
      console.log("Selected options:", selectedOptions);
      
      if (selectedOptions.length > 0) {
        // Look for media with these option values
        matchingMedia = allMediaItems.filter(item => {
          const alt = (item.querySelector('img')?.alt || '').toLowerCase();
          return selectedOptions.some(option => alt.includes(option));
        });
        
        console.log(`Found ${matchingMedia.length} media items matching option values`);
      }
    }
    
    // If still no matches, show the first image as fallback
    if (matchingMedia.length === 0) {
      console.log("No matching media found, showing first image as fallback");
      matchingMedia = [allMediaItems[0]];
    }
    
    // Make the first matching media active
    if (matchingMedia.length > 0) {
      const activeMedia = matchingMedia[0];
      activeMedia.classList.add('is-active');
      activeMedia.style.display = 'block';
      
      // Update thumbnails if needed
      if (allThumbnails.length > 0) {
        allThumbnails.forEach(thumb => {
          thumb.style.display = 'none';
          const thumbButton = thumb.querySelector('button');
          if (thumbButton) {
            thumbButton.setAttribute('aria-current', 'false');
          }
        });
        
        // Find and show the matching thumbnail
        const mediaId = activeMedia.getAttribute('data-media-id');
        if (mediaId) {
          const matchingThumbnail = allThumbnails.find(thumb => 
            thumb.getAttribute('data-target') === mediaId
          );
          
          if (matchingThumbnail) {
            matchingThumbnail.style.display = '';
            const thumbButton = matchingThumbnail.querySelector('button');
            if (thumbButton) {
              thumbButton.setAttribute('aria-current', 'true');
            }
          }
        }
      }
      
      // Update slider counter
      updateSliderCounter(1, 1);
    }
  }
  
  // Function to update the slider counter
  function updateSliderCounter(current, total) {
    const sliderCurrentCounter = document.querySelector('.slider-counter--current');
    if (sliderCurrentCounter) {
      sliderCurrentCounter.textContent = current.toString();
    }
    
    const sliderTotalCounter = document.querySelector('.slider-counter--total');
    if (sliderTotalCounter) {
      sliderTotalCounter.textContent = total.toString();
    }
  }
  
  // Handler for variant change events
  function handleVariantChange() {
    const variantId = getCurrentVariantId();
    if (variantId) {
      updateActiveMedia(variantId);
    }
  }
  
  // Set up event listeners for variant changes
  
  // 1. Listen for radio button changes
  const variantRadios = document.querySelectorAll('variant-radios input[type="radio"]');
  variantRadios.forEach(radio => {
    radio.addEventListener('change', handleVariantChange);
  });
  
  // 2. Listen for select dropdown changes
  const variantSelects = document.querySelectorAll('variant-selects select');
  variantSelects.forEach(select => {
    select.addEventListener('change', handleVariantChange);
  });
  
  // 3. Listen for our custom swatch UI clicks
  const swatchButtons = document.querySelectorAll('.variant-image-item');
  swatchButtons.forEach(button => {
    button.addEventListener('click', function() {
      // Give it a moment to update the hidden form
      setTimeout(handleVariantChange, 100);
    });
  });
  
  // 4. Listen for Shopify's variant:changed event
  document.addEventListener('variant:changed', function(event) {
    if (event.detail && event.detail.variant) {
      console.log("variant:changed event detected, variant ID:", event.detail.variant.id);
      updateActiveMedia(event.detail.variant.id.toString());
    }
  });
  
  // Initialize on page load
  function initialize() {
    if (isInitialized) return;
    
    console.log("Initializing variant media switching");
    const variantId = getCurrentVariantId();
    if (variantId) {
      updateActiveMedia(variantId);
    } else {
      // If we can't determine variant ID, show the first media item
      if (allMediaItems.length > 0) {
        allMediaItems[0].classList.add('is-active');
        allMediaItems[0].style.display = 'block';
        
        if (allThumbnails.length > 0) {
          allThumbnails[0].style.display = '';
          const thumbButton = allThumbnails[0].querySelector('button');
          if (thumbButton) {
            thumbButton.setAttribute('aria-current', 'true');
          }
        }
        
        updateSliderCounter(1, 1);
      }
    }
    
    isInitialized = true;
  }
  
  // Call initialize after a short delay to ensure DOM is ready
  setTimeout(initialize, 100);
  
  // Also initialize when the DOM is fully loaded
  if (document.readyState === 'complete') {
    initialize();
  } else {
    window.addEventListener('load', initialize);
  }
} 